import { default as domainAmbienceResource } from './resource/store'
import { default as domainAmbience } from './ambience/store'
import { default as domainAmbienceCategory } from './category/store'
import { default as domainAmbienceRoomReservation } from './room-reservation/store'
import { default as domainAmbienceScheduleActivity } from './schedule-activity/store'

export default {
    domainAmbienceResource,
    domainAmbience,
    domainAmbienceCategory,
    domainAmbienceRoomReservation,
    domainAmbienceScheduleActivity
}